/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Createdbyid2Inputs */

const en_entity_createdbyid2 = /** @type {(inputs: Entity_Createdbyid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Created By ID`)
};

const de_entity_createdbyid2 = /** @type {(inputs: Entity_Createdbyid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstellt von ID`)
};

/**
* | output |
* | --- |
* | "Created By ID" |
*
* @param {Entity_Createdbyid2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_createdbyid2 = /** @type {((inputs?: Entity_Createdbyid2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Createdbyid2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_createdbyid2(inputs)
	return de_entity_createdbyid2(inputs)
});
export { entity_createdbyid2 as "entity_createdById" }